import { request } from "./request";

export function queryDynamic(startIndex, length) {
  return request({
    url: '/dynamic/queryDynamic',
    params: { startIndex, length }
  })
}


export function totalDynamic() {
  return request({
    url: '/dynamic/totalDynamic',
  })
}


export function delDynamic(id) {
  return request({
    url: '/dynamic/delDynamic',
    params:{ id }
  })
}

export function insertDynamic(title, titleEn, word1, word1En, note1, note1En, word2, word2En, note2, note2En, word3, word3En, note3, note3En, word4, word4En,
                               note4, note4En, word5, word5En, note5, note5En, word6, word6En, note6, note6En, createdUser, imgLength) {
  return request({
    url: '/dynamic/insert',
    method: 'post',
    params: {
      title, titleEn, word1, word1En, note1, note1En, word2, word2En, note2, note2En, word3, word3En, note3, note3En, word4, word4En,
      note4, note4En, word5, word5En, note5, note5En, word6, word6En, note6, note6En, createdUser, imgLength
    }
  })
}
